




















import Vue from 'vue';
import { Getter } from 'vuex-class';
import Component from 'vue-class-component';
import LayoutNav from '../layouts/layout-nav.vue';
import HomeSection from '../components/home/HomeSection.vue';
import Banner from '../components/home/Banner.vue';
import HotCmpt from '../components/home/HotCmpt.vue';
import HotSpecials from '../components/home/HotSpecials.vue';
import Information from '../components/home/Information.vue';
import AboutUs from '../components/home/AboutUs.vue';
import Copyright from '../components/home/Copyright.vue';
import { CellGroup } from 'vant';
// import Slogan from '../components/home/Slogan.vue';
// import Footer from '../components/home/Footer.vue';
// import Overview from '../components/home/Overview.vue';
// import Schedule from '../components/home/Schedule.vue';
// import Introduction from '../components/home/Introduction.vue';
// import Characteristic from '../components/home/Characteristic.vue';
// import News from '../components/home/News.vue';
// import Data from '../components/home/Data.vue';
// import Award from '../components/home/Award.vue';
// import Expert from '../components/home/Expert.vue';
// import Live from '../components/home/Live.vue';
// import Organization from '../components/home/Organization.vue';
// import animation from '../components/home/animation';
@Component({
    components: {
        HomeSection,
        Banner,
        LayoutNav,
        HotCmpt,
        Information,
        AboutUs,
        Copyright,
        HotSpecials,
        // Footer,
        // Overview,
        // Schedule,
        // Introduction,
        // Characteristic,
        // News,
        // Data,
        // Award,
        // Expert,
        // Live,
        // Organization,
    },
})
export default class Home extends Vue {
    @Getter('userInfo') user!: any;
    private recommendRaces = { cmpt: [], specials: [] };

    mounted() {
        const fh: any = document.querySelector('.page');
        fh.scrollIntoView();
        this.fetchRecommendRaces();
    }

    async fetchRecommendRaces() {
        const { data } = await this.$axios('getHomeRecommendRaces', { type: 2, page: 1, pageSize: 3 });
        data.cmpt.forEach(c => {
            c.avatar = c.avatar.splice(0, 3);
        });

        this.recommendRaces = data;
    }
}
